<template>
    <div class="refund-dialog">
        <el-dialog
            class="form-dialog"
            title="退款申请"
            :visible.sync="refundShow"
            :before-close="refundCell"
            width="40%"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="70px"
                class="demo-ruleForm"
            >
                <el-form-item label="银行账号" prop="account" class="label-form">
                    <el-select v-model="ruleForm.account" placeholder="请在此输入银行账户" value-key="bankAccount" @change="changeHandler">
                        <el-option
                            v-for="item in accountOptions"
                            :key="item.bankCode"
                            :label="item.bankAccount"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户行" prop="bankName">
                    <el-input v-model="ruleForm.bankName" placeholder="开户行" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="账户名称" prop="bankAccountName">
                    <el-input v-model="ruleForm.bankAccountName" placeholder="账户名称" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="退款金额" prop="refundAmount">
                    <el-input v-model="ruleForm.refundAmount" @keyup.native="inputpayMoney(ruleForm.refundAmount)" placeholder="请输入退款金额"></el-input>
                </el-form-item>
                <el-form-item label="附件上传" prop="annex">
                    <el-upload class="upload-demo" action accept=".pdf" multiple :limit="3" :before-remove="beforeRemove" :on-remove="handleRemove" :before-upload="beforeAvatarUpload"
                    :http-request="submitUpload" :on-exceed="handleExceed" :file-list="fileList">
                        <el-button size="mini" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="参考文件" prop="">
                    <div class="download-right">
                        <el-row :gutter="20" v-for="(item, index) in fillNameList" :key="index">
                            <el-col :span="16" class="download-name"><div>{{item.substr1}}</div></el-col>
                            <el-col :span="6" class="download-fill"><span @click="downloadFillList(item)">下载</span></el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item label prop="electronicSignature">
                    <div class="contens">
                        <div class="contens-tip">
                            提示：退款前请查阅
                            <span class="hyperlink" @click="downloadPDF">《退款申请函》</span>，查阅后点击电子签章进行盖印再提交申请。
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="refundCell">取 消</el-button>
                <Throttle delay="500">
                    <el-button :disabled="isDisabled" @click="refundOk('ruleForm')" :loading="isLoading">
                        <i class="el-icon-check confirm" v-if="isCondition"></i>电子签章
                    </el-button>
                </Throttle>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Throttle from '@/components/lots/debounce/Debounce';
import configs from '../../../../../../../../src/config/user.env';
import { onlyInputnumber, stAi, messageBox } from '../../../../components/judge/bmsModular';
import { geBankAccountLists, getElectronicSeal } from '../../../../api/refundDialog';
import { getControlParam } from '../../../../api/common';
export default {
    components: { Throttle },
    props: {
        refundShow: {
            type: Boolean,
            default: false
        },
        balance: {
            type: Number
        },
        dataBalanceObj: {
            type: Object
        },
        dataId: {
            type: String
        },
        businessId: {
            type: Number
        },
        dataUrl: {
            type: String
        }
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value > this.balance) {
                return callback(new Error('退款金额不可以大于余额'));
            } else {
                callback();
            }
        };
        return {
            fileList: [],
            uploadList: [],
            isDisabled: false,
            isLoading: false,
            isCondition: false,
            ruleForm: {
                refundAmount: '',
                account: '',
                bankName: '',
                bankAccountName: '',
                electronicSignature: '',
                annex: ''
            },
            rules: {
                account: [
                    { required: true, message: '请选择银行账户', trigger: 'change' }
                ],
                annex: [
                    // { required: true, message: '请先上传附件', trigger: 'change' }
                ],
                refundAmount: [
                    { required: true, message: '请输入退款金额', trigger: 'blur' },
                    { required: true, validator: validatePass, trigger: 'blur' }
                ]
            },
            accountOptions: [],
            value: '',
            accountNumberObj: {},
            accountObj: {},
            uploadData: [],
            fillNameList: [
                {
                    substr1: '《往来对账余额调节表》',
                    id: 1
                },
                {
                    substr1: '《业务终止登记表》',
                    id: 2
                }
            ],
            controlParamSize: 1024
        };
    },
    created() {
        this.getLists();
    },
    methods: {
        downloadFillList(item) {
            if (item.id === 1) {
                window.open(`${configs.apiUrl}/api-bms-web/depositManagement/getDownloadWord`);
            } else {
                window.open(`${configs.apiUrl}/api-bms-web/depositManagement/getDowWord`);
            }
            // http://anapi-uat.annto.com ${configs.apiUrl}
        },
        submitUpload(uploadData) {
            if (uploadData) {
                this.uploadData.push(uploadData);
            }
        },
        beforeAvatarUpload(file) {
            const isPDF = file.type.split('/');
            const isJPG = isPDF[1] === 'pdf';
            if (!isJPG) {
                this.$message.closeAll();
                this.$message.error('仅支持上传pdf文件');
                return false;
            }
            const isExceed = file.size / 1024 <= this.controlParamSize;
            if (!isExceed) {
                this.$message.warning('上传文件大小不能超过 ' + this.controlParamSize + 'KB');
                return false;
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            if (file.type !== 'pdf') {
                return true;
            }
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
            let temp = null;
            this.uploadData.forEach((item, index) => {
                if (file.name === item.file.name) {
                    temp = index;
                }
            });
            this.uploadData.splice(temp, 1);
        },
        getLists() {
            const params = { suppliersCode: this.dataBalanceObj.suppCode, ledgerId: this.dataBalanceObj.ledgerId };
            geBankAccountLists(params).then(res => {
                if (res && res.code === '0') {
                    this.accountOptions = res.data;
                }
            }).catch(() => {});
        },
        refundOk(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.dataUrl === '') {
                        return this.$message.warning('请先下载退款函');
                    }
                    this.$emit('refundOk', { state: true,
                        file: this.uploadData,
                        data: this.ruleForm,
                        businessId: this.businessId,
                        supCashNo: this.$route.query.supCashNo,
                        accountName: this.accountNumberObj.bankAccount,
                        applyAmt: this.ruleForm.refundAmount,
                        applyType: '2' }, () => {
                        this.uploadData = [];
                    });
                } else {
                    this.$emit('refundOk', { state: false, form: valid, data: {} });
                    return false;
                }
            });
        },
        changeHandler(val) {
            this.accountNumberObj = val;
            this.ruleForm = stAi(this.accountNumberObj, this.ruleForm);
        },
        downloadPDF() {
            if (this.ruleForm['account'] === '' || this.ruleForm['refundAmount'] === '') {
                return this.$message.warning('银行账号或者退款金额不能为空');
            }
            this.$emit('downloadPDF', { data: this.ruleForm });
        },
        inputpayMoney(val) {
            this.ruleForm.refundAmount = onlyInputnumber(val);
        },
        signature(electronicSignature) {
            if (this.ruleForm.account === '' || this.ruleForm.refundAmount === '') {
                return this.$message.warning('银行账户或退款金额不能为空!');
            }
            if (this.dataUrl !== '') {
                const params = { data: this.dataId, url: this.dataUrl };
                getElectronicSeal(params).then(res => {
                    if (res && res.code === '0') {
                        this.ruleForm.electronicSignature = '1';
                        this.isDisabled = true;
                    }
                }).catch(() => {});
            } else {
                return this.$message.warning('请先下载退款函');
            }
        },
        refundCell() {
            messageBox(this).then(() => {
                this.$emit('refundCell', '');
            }).catch(() => {});
        },
        getControlParamSize() {
            // 获取系统控制参数
            const formData = new FormData();
            formData.append('controlParam', 'BMS_UPLOAD_FILE_SIZE_CONTROL');
            getControlParam(formData).then(res => {
                if (res && res.code === '0') {
                    this.controlParamSize = res.data.value;
                } else {
                    this.controlParamSize = 1024; // 默认1024KB
                }
            });
        }
    },
    mounted() {
        this.getControlParamSize();
    }
};
</script>

<style lang="less">
@import './refundDialog.less';
</style>
